module.exports = __webpack_public_path__ + "img/voucher_frame.b75aa70f.png";